/**
 * @spec docs/specs/features/staking-position-ui.md#wallet-integration
 * Hook to access the wallet context
 */
import { useContext } from 'react';
import { WalletContext, type WalletContextValue } from '@/contexts/wallet-context';

/**
 * Hook to access the wallet context
 * @throws Error if used outside WalletProvider
 */
export function useWalletContext(): WalletContextValue {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWalletContext must be used within a WalletProvider');
  }
  return context;
}

/**
 * Same context, but null outside a WalletProvider instead of throwing. For leaf UI (network pill,
 * gated buttons) that must also render in isolated component tests without a provider.
 */
export function useOptionalWalletContext(): WalletContextValue | null {
  return useContext(WalletContext);
}
